var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_2118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7456 0.5H0V24.5H29.7456V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_2118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17824 0.503662C4.48103 0.503662 3.22517 2.00794 3.28139 3.63926C3.33537 5.20654 3.26525 7.23634 2.76061 8.89166C2.25412 10.5516 1.39827 11.6036 0 11.7386V13.263C1.39827 13.3983 2.25412 14.4497 2.76054 16.1099C3.26525 17.7652 3.3353 19.7951 3.28131 21.3624C3.22509 22.9934 4.48095 24.4979 6.17846 24.4979H23.5696C25.2669 24.4979 26.5225 22.9937 26.4663 21.3624C26.4123 19.7951 26.4824 17.7652 26.9871 16.1099C27.4935 14.4497 28.3473 13.3979 29.7456 13.263V11.7386C28.3473 11.6033 27.4936 10.5519 26.9871 8.89166C26.4824 7.23656 26.4123 5.20654 26.4663 3.63926C26.5225 2.00816 25.2669 0.503662 23.5696 0.503662H6.17824ZM20.1665 15.2737C20.1665 17.52 18.5119 18.8823 15.7659 18.8823H11.0915C10.9578 18.8823 10.8296 18.8285 10.735 18.7327C10.6405 18.637 10.5874 18.5072 10.5874 18.3717V6.62989C10.5874 6.49451 10.6405 6.36461 10.735 6.26891C10.8296 6.17314 10.9578 6.11936 11.0915 6.11936H15.7393C18.029 6.11936 19.5316 7.37524 19.5316 9.30341C19.5316 10.6568 18.5207 11.8684 17.2329 12.0807V12.1512C18.986 12.3459 20.1665 13.5755 20.1665 15.2737ZM15.2562 7.73771H12.591V11.5498H14.8358C16.5711 11.5498 17.528 10.8422 17.528 9.57746C17.5278 8.39216 16.7052 7.73771 15.2562 7.73771ZM12.591 13.0623V17.2634H15.3543C17.1611 17.2634 18.1181 16.5293 18.1181 15.1497C18.1181 13.77 17.1343 13.0621 15.2381 13.0621L12.591 13.0623Z",
    fill: "#7952B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.b71225a95ce7b2f7da4f742391fdf6c7.svg";
export { ForwardRef as ReactComponent };